import React, { Component } from 'react';

import Css from './Slider.scss';
import ImportImages from '@src/importImages';

const Slider1 = ImportImages('/slider/bkg1.jpg');
const Slider2 = ImportImages('/slider/bkg2.jpg');
const Slider3 = ImportImages('/slider/bkg3.jpg');

class Slider extends Component {
  state = {
    activeSlider: 0
  };

  activeInterval = null;

  handleImageLoaded = obj => {
    const sliderImg = document.getElementsByClassName('slider-img')[
      this.state.activeSlider
    ];
    sliderImg.classList.remove('fadeOut');
    sliderImg.classList.add('animated');
    sliderImg.classList.add('fadeIn');
    setTimeout(() => {
      sliderImg.classList.add('zoom');
      this.activeInterval = setInterval(() => this.switchSlider(), 3500);
    }, 500);
  };

  componentWillUnmount = () => {
    clearInterval(this.activeInterval);
  };

  switchSlider = () => {
    let currentSlide = this.state.activeSlider;

    const sliderImg = document.getElementsByClassName('slider-img')[
      currentSlide
    ];
    sliderImg.classList.remove('fadeIn');
    sliderImg.classList.add('fadeOut');
    currentSlide++;
    this.setState({
      activeSlider: currentSlide % 3
    });

    const activeSliderImg = document.getElementsByClassName('slider-img')[
      this.state.activeSlider
    ];
    activeSliderImg.classList.remove('fadeOut');
    activeSliderImg.classList.add('animated');
    activeSliderImg.classList.add('fadeIn');
    activeSliderImg.classList.add('zoom');

    setTimeout(() => {
      sliderImg.classList.remove('zoom');
      sliderImg.classList.remove('animated');
    }, 3500);
  };

  render() {
    let heightStyle = {
      height: this.props.screenHeight + 'px'
    };

    return (
      <div
        id={this.props.id}
        className={this.props.className}
        style={heightStyle}
      >
        <div className={'h-100 w-100 d-none d-md-block position-relative'}>
          <img
            src={Slider1}
            alt={'Slider1'}
            className={
              Css['slider-img'] + ' slider-img img-fluid animated-slow'
            }
            onLoad={() => this.handleImageLoaded(this)}
          />
          <img
            src={Slider3}
            alt={'Slider1'}
            className={
              Css['slider-img'] + ' slider-img img-fluid animated-slow fadeOut'
            }
          />
          <img
            src={Slider2}
            alt={'Slider1'}
            className={
              Css['slider-img'] + ' slider-img img-fluid animated-slow fadeOut'
            }
          />
        </div>
        <div className={'h-100 d-md-none'}>
          <img
            src={this.props.sliderImg}
            alt={'Slider1'}
            className={Css['slider-img'] + ' img-fluid'}
          />
        </div>
      </div>
    );
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Home/Slider/Slider.js